import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export default function InviteSetup() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get(`/auth/invite?token=${encodeURIComponent(token)}`);
        if (data.ok) setEmail(data.email);
      } catch (e) {
        setStatus("Ogiltig eller utgången länk.");
      }
    };
    if (token) check();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    if (!firstName.trim() || !lastName.trim()) return setStatus("Ange för- och efternamn.");
    if (newPassword.length < 8) return setStatus("Lösenord måste vara minst 8 tecken.");
    try {
      await api.post(`/auth/invite?token=${encodeURIComponent(token)}`, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        newPassword,
      });
      await refreshUser();
      setStatus("Klart! Du loggades in.");
      navigate("/", { replace: true });
    } catch (e) {
      setStatus(e?.response?.data?.message || "Kunde inte slutföra registreringen.");
    }
  };

  if (!token) return <div className="container">Ingen token angiven.</div>;

  return (
    <div className="container mt-3" style={{ maxWidth: 480 }}>
      <h3 className="mb-3">Fortsätt registrering</h3>
      {email && <p className="text-muted">Konto: <b>{email}</b></p>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Förnamn</label>
          <input className="form-control" value={firstName} onChange={e => setFirstName(e.target.value)} />
        </div>
        <div className="mb-3">
          <label className="form-label">Efternamn</label>
          <input className="form-control" value={lastName} onChange={e => setLastName(e.target.value)} />
        </div>
        <div className="mb-3">
          <label className="form-label">Välj lösenord (minst 8 tecken)</label>
          <input type="password" className="form-control" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
        </div>
        <button className="btn btn-success w-100">Slutför och logga in</button>
      </form>

      {status && <div className="alert alert-info mt-3">{status}</div>}
    </div>
  );
}
